import React from 'react';
import {View, Text, StyleSheet} from 'react-native';
import {useTranslation} from 'react-i18next';
import {MATERIAL_ICONS_FONT} from '../styles/fonts';
import {useNetworkStatus} from '../hooks/useNetworkStatus';

export default function OfflineBanner() {
  const {t} = useTranslation();
  const isOnline = useNetworkStatus();

  if (isOnline) return null;

  return (
    <View style={styles.banner}>
      <Text style={styles.icon}>wifi_off</Text>
      <Text style={styles.text}>{t('common.noInternet')}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: 'rgba(251, 191, 36, 0.15)',
    borderWidth: 1,
    borderColor: 'rgba(251, 191, 36, 0.3)',
    borderRadius: 12,
    paddingVertical: 10,
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  icon: {
    fontFamily: MATERIAL_ICONS_FONT,
    fontSize: 20,
    color: '#fbbf24',
  },
  text: {
    fontSize: 14,
    fontWeight: '500',
    color: '#fbbf24',
  },
});
